import router from 'next/router'

import Typeahead from '@/components/Typeahead/Typeahead'
import { SetType } from '@/store/misc/initialState'

const SubNavSearch = () => (
  <div className='pb-3 pt-2'>
    <Typeahead
      icon='search'
      onChange={(sets) => {
        if (sets.length > 0) {
          const { code } = sets[0] as SetType
          router.push(`/sets/${code}`)
        }
      }}
      placeholder='Search sets...'
      type='sets'
    />
  </div>
)

export default SubNavSearch
